export type AuthCodeDeliveryChannel = 'telegram_sms' | 'telegram' | 'sms' | 'voice_call' | 'app_push' | 'log';

export const AUTH_CODE_DELIVERY_EXPECTATION = 'Код подтверждения придёт в Telegram или по SMS';

export const CLIENT_AUTH_CODE_DELIVERY_EXPECTATION = 'Код подтверждения придёт уведомлением в приложение Vetsy, в Telegram или по SMS';

export const DOCTOR_PHONE_LOGIN_TITLE = 'Войдите по номеру телефона';

export const DOCTOR_PIN_BLOCKED_ALERT =
    'ПИН заблокирован. Войдите по коду и установите новый ПИН.';

export const AUTH_CODE_PHONE_CONFIRM_NOTE = `Необходимо подтвердить номер телефона. ${AUTH_CODE_DELIVERY_EXPECTATION}.`;

export const CLIENT_AUTH_CODE_PHONE_CONFIRM_NOTE = `Необходимо подтвердить номер телефона. ${CLIENT_AUTH_CODE_DELIVERY_EXPECTATION}.`;

const DELIVERY_CHANNEL_HINTS: Record<AuthCodeDeliveryChannel, string> = {
    telegram_sms: 'Отправили код в Telegram. Если не пришёл — придёт по SMS',
    telegram: 'Отправили код в Telegram. Если не видите — проверьте SMS',
    sms: 'Отправили код по SMS. Если не пришла — проверьте Telegram',
    voice_call: 'Сейчас позвоним — робот продиктует код',
    app_push: 'Отправили код уведомлением в приложение Vetsy на телефоне. Если не пришёл — запросите код повторно, он придёт в Telegram или по SMS',
    log: 'Код записан в storage/logs/laravel.log (локальная разработка)',
};

export function isAuthCodeDeliveryChannel(value: unknown): value is AuthCodeDeliveryChannel {
    return (
        value === 'telegram_sms' ||
        value === 'telegram' ||
        value === 'sms' ||
        value === 'voice_call' ||
        value === 'app_push' ||
        value === 'log'
    );
}

export function getAuthCodeDeliveryHint(channel?: AuthCodeDeliveryChannel | null, mayUseApp = false): string {
    if (!channel) {
        return mayUseApp ? CLIENT_AUTH_CODE_DELIVERY_EXPECTATION : AUTH_CODE_DELIVERY_EXPECTATION;
    }

    return DELIVERY_CHANNEL_HINTS[channel];
}

export function shouldShowPhoneConfirmNote(options: {
    needsConfirm: boolean;
    authStep: number;
    hasPhoneError: boolean;
}): boolean {
    return options.needsConfirm && options.authStep === 1 && !options.hasPhoneError;
}

export function getAuthCodeStepTitle(channel?: AuthCodeDeliveryChannel | null, mayUseApp = false): string {
    if (!channel && mayUseApp) {
        return 'Введите код подтверждения';
    }

    if (channel === 'voice_call') {
        return 'Введите код из звонка';
    }

    if (channel === 'app_push') {
        return 'Введите код из приложения Vetsy';
    }

    if (channel === 'log') {
        return 'Введите код подтверждения';
    }

    return 'Введите код из Telegram или SMS';
}
